import { useMediaQuery } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import { DEVICES } from '../../const';
import ProfileImageSource from '../../assets/profile.png';


const Container = styled.div`
  background-color: #F2EFEA;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 42px;

  @media ${DEVICES.mobile} {
    padding: 60px 0;
  }

  @media ${DEVICES.tablet} {
    padding: 100px 0;
  }

  @media ${DEVICES.large} {
  }
`;

const Heading = styled.div`
font-weight: 700;

  @media ${DEVICES.mobile} {
    font-size: 0.9rem;
  }
  
  @media ${DEVICES.tablet} {
    font-size: 1.25rem;
  }

  @media ${DEVICES.large} {
  }
`;

const Title = styled.div`
  font-weight: 700;
  margin-top: 1.5rem;
  text-align: center;

  @media ${DEVICES.mobile} {
    font-size: 1.5rem;
    line-height: 1.5;
  }
  
  @media ${DEVICES.tablet} {
    line-height: 64px;
    font-size: 2.5rem;
  }

  @media ${DEVICES.large} {
  }
`;

const Description = styled.div`
  margin-top: 2.5rem;
  @media ${DEVICES.mobile} {
    font-size: 0.9rem;
  }
  
  @media ${DEVICES.tablet} {
    font-size: 1.25rem;
  }

  @media ${DEVICES.large} {
  }
`;

const Profiles = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 60px;
  justify-content: center;
`;


const Profile = styled.div`
  padding: 0.5rem;
  @media ${DEVICES.mobile} {
  }
  
  @media ${DEVICES.tablet} {
  }

  @media ${DEVICES.large} {
  }
`;

const ProfileImg = styled.img`
  @media ${DEVICES.mobile} {
    height: 138px;
    width: 138px;
  }
  
  @media ${DEVICES.tablet} {
    height: 265px;
    width: 265px;
  }

  @media ${DEVICES.large} {
  }
`;

const ProfileName = styled.div`
  line-height: 20px
  @media ${DEVICES.mobile} {
    font-size: 14px;
  }
  
  @media ${DEVICES.tablet} {
    font-size: 20px;
  }

  @media ${DEVICES.large} {
  }
`;


export default function AboutFourthBanner() {

  const overTablet = useMediaQuery(DEVICES.tablet);

  const descriptionTemplate = () => {
    if (overTablet) {
      return <div>
        스포츠교육 관련 석사 연구 및 다양한 스포츠 지도 경력을 가지고 있습니다. <br />
        현재 캥거루짐의 모든 수업은 원장님과 부원장님이 <br />
        캥거루짐의 교육 시스템을 이수한 강사진과 함께 직접 진행하고 있습니다.
      </div>
    } else {
      return <div>
        스포츠교육 관련 석사 연구 및 <br />
        다양한 스포츠 지도 경력을 가지고 있습니다. <br />
        현재 캥거루짐의 모든 수업은 원장님과 <br />
        부원장님이 캥거루짐의 교육 시스템을 <br />
        이수한 강사진과 함께 직접 진행하고 있습니다. <br />
      </div>
    }
  };

  return <Container>
    <Heading>
      캥거루짐 원장님과 부원장님 모두
    </Heading>
    <Title>
      성균관대학교 스포츠과학과 출신이며,
    </Title>
    <Description>
      {descriptionTemplate()}
    </Description>
    <Profiles>
      <Profile>
        <ProfileImg src='https://kangaroo-edu-main.s3.ap-northeast-2.amazonaws.com/landing-page/about/profile1.png' />
        <ProfileName>
          <strong>김종혁</strong>원장
        </ProfileName>
      </Profile>
      <Profile>
        <ProfileImg src='https://kangaroo-edu-main.s3.ap-northeast-2.amazonaws.com/landing-page/about/profile2.png' />
        <ProfileName>
          <strong>유원태</strong>부원장
        </ProfileName>
      </Profile>
      {/* <Profile>
        <ProfileImg src={ProfileImageSource} />
        <ProfileName>
          <strong>홍길동</strong>강사
        </ProfileName>
      </Profile>
      <Profile>
        <ProfileImg src={ProfileImageSource} />
        <ProfileName>
          <strong>홍길동</strong>강사
        </ProfileName>
      </Profile> */}
    </Profiles>
  </Container>
}
